import React from "react";
import "./PredictionMetrics.css";

const PredictionMetrics = ({ fire }) => {
  const hasMetrics =
    fire.nb_of_hours != null ||
    fire.nb_of_polygons != null ||
    fire.dt_polygons != null;

  if (!hasMetrics) return null;

  return (
    <div className="prediction-metrics">
      {fire.nb_of_hours != null && (
        <div className="metric-pill">
          <span className="metric-label">Durée</span>
          <span className="metric-value">{fire.nb_of_hours}h</span>
        </div>
      )}
      {fire.nb_of_polygons != null && (
        <div className="metric-pill">
          <span className="metric-label">Polygones</span>
          <span className="metric-value">{fire.nb_of_polygons}</span>
        </div>
      )}
      {fire.dt_polygons != null && (
        <div className="metric-pill">
          <span className="metric-label">Pas de temps</span>
          <span className="metric-value">{fire.dt_polygons} min</span>
        </div>
      )}
    </div>
  );
};

export default PredictionMetrics;

